export default "__VITE_ASSET__alRwBU6f__"